import apiClient from '../axios.js';

export const moduleService = {
  // 獲取模組列表
  getModules: async (params) => {
    const response = await apiClient.get('/system/modules', { params });
    return response;
  },

  // 獲取模組詳情
  getById: async (id) => {
    const response = await apiClient.get(`/system/modules/${id}`);
    return response;
  },

  // 創建模組
  create: async (data) => {
    const response = await apiClient.post('/system/modules', data);
    return response;
  },

  // 更新模組
  update: async (id, data) => {
    const response = await apiClient.put(`/system/modules/${id}`, data);
    return response;
  },

  // 刪除模組
  deleteModule: async (id) => {
    const response = await apiClient.delete(`/system/modules/${id}`);
    return response;
  },

  // 檢查模組代碼是否可用
  checkCode: async (moduleCode) => {
    const response = await apiClient.get(`/system/modules/check/${moduleCode}`);
    return response;
  },

  // 批次更新排序
  reorder: async (items) => {
    const response = await apiClient.patch('/system/modules/reorder', { items });
    return response;
  },
};
